module.exports = __webpack_public_path__ + "images/emoji/hamburger.989a828e2fd805742f2f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hamburger.png
// module id = Eoj7
// module chunks = 1